import React from '../../../_snowpack/pkg/react.js';
import LoadingSpinner from '../../modules/loading-spinner.js';
import MailBoxSrc from '../../images/illustrations/mailbox.png';
import { DialogWrapper } from './styles.js';

function MagicDialog({
  resendEmail,
  heading,
  subHeading
}) {
  const displayHeading = heading || 'Check your inbox';
  const displaySubHeading = subHeading || 'Follow the link we sent you.';
  const [resending, setResending] = React.useState(false);
  const [msg, setMsg] = React.useState('');

  async function onClick() {
    setResending(true);

    try {
      const response = await resendEmail();

      if (response.ok) {
        setMsg('The email has been resent');
      } else {
        setMsg('Could not resend the magic link email. Please start over.');
      }
    } catch (e) {
      setMsg('Could not resend the magic link email. Please start over.');
    }

    setResending(false);
  }

  return /*#__PURE__*/React.createElement(DialogWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("img", {
    src: MailBoxSrc,
    alt: "Mail box"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, displayHeading), /*#__PURE__*/React.createElement("p", null, displaySubHeading), msg && /*#__PURE__*/React.createElement("p", null, msg))), !msg && resendEmail && /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: resending,
    onClick: onClick
  }, "Resend email", resending && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(LoadingSpinner, null))));
}

export default MagicDialog;